import { MessagingDependenciesFactory } from "./dependencies.factory";

export const messagingEpicsDependencies = {
    messagingService: MessagingDependenciesFactory.getMessagingService()
}
